module.exports = __webpack_public_path__ + "static/img/SearchRisk.5ac7468d.png";